
import { useParams, Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

export default function BlogDetailPage() {
  const { id } = useParams();

  // Mock data - gerçek uygulamada API'den gelecek
  const post = {
    id: 1,
    title: 'Modern İnşaat Teknolojilerinin Geleceği',
    category: 'İnşaat Teknolojileri',
    date: '15 Ocak 2024',
    author: 'Mimar Ahmet Yılmaz',
    readTime: '5 dk',
    image: 'https://public.readdy.ai/ai/img_res/fcfd477a3b1a0fa8c81dedff08f7cdf2.jpg',
    content: `
      <p>İnşaat sektörü, teknolojik gelişmelerle birlikte hızla dönüşüm geçiriyor. Yapay zeka, robotik sistemler ve sürdürülebilir malzemeler, gelecekteki inşaat projelerinin temel taşlarını oluşturuyor.</p>

      <h2>Yapay Zeka ve Otomasyon</h2>
      <p>Yapay zeka teknolojileri, inşaat süreçlerinde verimliliği artırırken, hata oranlarını minimize ediyor. Proje planlama aşamasından başlayarak, malzeme optimizasyonu ve kalite kontrolüne kadar birçok alanda kullanılıyor.</p>

      <h2>Robotik Sistemler</h2>
      <p>İnşaat robotları, tehlikeli ve tekrarlayan işleri üstlenerek iş güvenliğini artırıyor. Özellikle yüksek katlı binaların inşaatında, robotik sistemler büyük avantaj sağlıyor.</p>

      <h2>Sürdürülebilir Malzemeler</h2>
      <p>Çevre dostu malzemeler ve enerji verimli çözümler, modern inşaat projelerinin vazgeçilmez unsurları haline geliyor. Geri dönüştürülebilir malzemeler ve yenilenebilir enerji sistemleri öne çıkıyor.</p>

      <h2>Gelecek Projeksiyonları</h2>
      <p>Önümüzdeki 10 yıl içinde, inşaat sektöründe tam otomatik sistemler ve akıllı binalar standart hale gelecek. Bu dönüşüm, hem maliyet avantajı hem de çevresel fayda sağlayacak.</p>
    `
  };

  const relatedPosts = [
    {
      id: 2,
      title: 'Sürdürülebilir İnşaat Malzemeleri Rehberi',
      category: 'Sürdürülebilirlik',
      image: 'https://readdy.ai/api/search-image?query=sustainable%20construction%20materials%20display%2C%20eco-friendly%20building%20supplies%20and%20green%20construction%20products%2C%20environmental%20building%20materials%2C%20clean%20background&width=300&height=200&seq=32&orientation=landscape'
    },
    {
      id: 3,
      title: 'Akıllı Bina Sistemleri ve IoT Entegrasyonu',
      category: 'İnşaat Teknolojileri',
      image: 'https://readdy.ai/api/search-image?query=smart%20building%20technology%20with%20IoT%20sensors%20and%20automation%20systems%2C%20modern%20intelligent%20building%20interior%2C%20connected%20home%20technology%2C%20clean%20background&width=300&height=200&seq=33&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Breadcrumb */}
      <section className="pt-24 pb-4">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-[14px] text-gray-600">
            <Link to="/" className="hover:text-[#0e3851]">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/blog" className="hover:text-[#0e3851]">Blog</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0e3851]">{post.title}</span>
          </nav>
        </div>
      </section>

      {/* Article */}
      <article className="py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <header className="mb-8">
            <div className="flex items-center gap-4 mb-4">
              <span className="px-3 py-1 bg-[#0e3851]/10 text-[#0e3851] text-[14px] font-medium rounded-full">
                {post.category}
              </span>
              <div className="flex items-center text-[14px] text-gray-500">
                <i className="ri-time-line mr-1"></i>
                {post.readTime}
              </div>
            </div>
            
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4 leading-tight">
              {post.title}
            </h1>
            
            <div className="flex items-center justify-between text-[14px] text-gray-600 mb-6">
              <div className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                {post.author}
              </div>
              <div className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                {post.date}
              </div>
            </div>
            
            <img 
              src={post.image}
              alt={post.title}
              className="w-full h-80 object-cover rounded-2xl"
            />
          </header>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div 
              className="text-[15px] text-gray-700 leading-relaxed space-y-6"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </div>

          {/* Share */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <h3 className="text-[16px] font-semibold text-[#0e3851] mb-4">Bu yazıyı paylaş</h3>
            <div className="flex gap-4">
              <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors text-[14px]">
                <i className="ri-facebook-fill mr-2"></i>
                Facebook
              </button>
              <button className="flex items-center px-4 py-2 bg-sky-500 text-white rounded-xl hover:bg-sky-600 transition-colors text-[14px]">
                <i className="ri-twitter-fill mr-2"></i>
                Twitter
              </button>
              <button className="flex items-center px-4 py-2 bg-blue-700 text-white rounded-xl hover:bg-blue-800 transition-colors text-[14px]">
                <i className="ri-linkedin-fill mr-2"></i>
                LinkedIn
              </button>
              <button className="flex items-center px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors text-[14px]">
                <i className="ri-whatsapp-fill mr-2"></i>
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-[22px] font-semibold text-[#0e3851] mb-8 text-center">İlgili Yazılar</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {relatedPosts.map((relatedPost) => (
              <Card key={relatedPost.id} hover>
                <img 
                  src={relatedPost.image}
                  alt={relatedPost.title}
                  className="w-full h-48 object-cover rounded-xl mb-4"
                />
                <span className="px-3 py-1 bg-[#0e3851]/10 text-[#0e3851] text-[12px] font-medium rounded-full mb-3 inline-block">
                  {relatedPost.category}
                </span>
                <h3 className="text-[16px] font-semibold text-[#0e3851] mb-4">{relatedPost.title}</h3>
                <Link to={`/blog/${relatedPost.id}`}>
                  <Button variant="outline" size="sm" className="w-full">
                    <i className="ri-arrow-right-line mr-2"></i>
                    Oku
                  </Button>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
